module.exports = {
  loadFeatures: async function () {
    const restrictionsFacade = require('../../../../../facade/restrictions/restrictions');

    return await Promise.all([
      restrictionsFacade.initialize(),
      INKIVE.CompanyFactory.getCompanyItems('features')
    ]).then(([_, companyFeatures]) => [restrictionsFacade, companyFeatures]);
  },

  render: async function () {
    const [
      restrictionsFacade,
      companyFeatures
    ] = await this.loadFeatures();

    const can = _.bind(restrictionsFacade.isFunctionalityAllowed, restrictionsFacade);

    _.each(this.tabs, function (tab) {
      switch (tab.key) {
        case 'add':
          tab.type = can('icon_add') ? tab.type : _.without(tab.type, 'icon');
          tab.type = can('video_add') ? tab.type : _.without(tab.type, 'video');
          tab.type = can('function_use_own_images') ? tab.type : _.without(tab.type, 'image');
          break;

        case 'stock':
          tab.type = can('function_use_desygner_vector') ? tab.type : _.without(tab.type, 'icon');

          if (this.type === 'image') {
            const isStockEnabledInWorkspace = companyFeatures.white_label.includes('show_marketplace');

            tab.searchable = can('function_use_web_images') && isStockEnabledInWorkspace;
            tab.type = (can('function_use_desygner_background') || tab.searchable) && isStockEnabledInWorkspace
              ? tab.type
              : _.without(tab.type, 'image');
          }

          break;

        case 'library':
          tab.type = can('function_use_asset_vector') ? tab.type : _.without(tab.type, 'icon');
          tab.type = can('function_use_asset_images') ? tab.type : _.without(tab.type, 'image');
          tab.type = can('function_use_desygner_background') ? tab.type : _.without(tab.type, 'image');
          break;

        case 'user_library':
          tab.type = can('function_use_own_images') ? tab.type : _.without(tab.type, 'image');
          break;

        case 'mns':
          tab.type = can('image_add') || can('image_content') ? tab.type : _.without(tab.type, 'kwls');
          break;
      }
    }, this);

    this._parentObject.prototype.render.call(this);
  }
};
